export default __webpack_public_path__ + "static/media/aula-virtual.d00efc1c.png";